import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import { read } from "redux/notification/slice";

// Components
import NotificationListMobile from "components/organisms/NotificationListMobile";

// Selectors
import * as notificationSelector from "redux/notification/selectors";

const NotificationListMobileContainer = () => {
  const dispatch = useDispatch();
  const notificationList = useSelector(notificationSelector.notificationList);

  useEffect(() => {
    return () => {
      dispatch(read());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <NotificationListMobile notificationList={notificationList} />;
};

export default NotificationListMobileContainer;
